import { CheckoutActions } from '../actions';
import { CustomCheckoutState } from '../checkout-state';

export const initialState: CustomCheckoutState['customDate'] = undefined;

export function reducer(
  state = initialState,
  action:
    | CheckoutActions.TimeSlotsActions
    | CheckoutActions.SelectTimeSlotsCustomDate
    | CheckoutActions.ResetTimeSlotsCustomDate,
): CustomCheckoutState['customDate'] {
  switch (action.type) {
    case CheckoutActions.SELECT_TIME_SLOTS_CUSTOM_DATE: {
      return action.payload;
    }

    case CheckoutActions.RESET_LOADED_TIME_SLOTS:
    case CheckoutActions.LOAD_TIME_SLOTS_FAIL:
    case CheckoutActions.RESET_TIME_SLOTS_ACTIVE_OPTION:
    case CheckoutActions.LOAD_TIME_SLOTS_FOR_CUSTOM_DATE_FAIL:
    case CheckoutActions.RESET_LOADED_TIME_SLOTS_FOR_CUSTOM_DATE:
    case CheckoutActions.RESET_TIME_SLOTS_CUSTOM_DATE: {
      if (state) {
        return initialState;
      }

      return state;
    }

    default: {
      return state;
    }
  }
}
